import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import { validate } from "./lib/api";
import { ThemeProvider } from "./ThemeContext";

function Root() {
  const [authState, setAuthState] = useState("checking");

  useEffect(() => {
    const path = window.location.pathname;
    if (path === "/magic" || path.startsWith("/magic/")) {
      setAuthState("no-token");
      return;
    }

    const token = localStorage.getItem("fw_token");
    if (!token) {
      setAuthState("no-token");
      return;
    }

    let cancelled = false;

    const doValidate = async () => {
      try {
        await validate();
        if (!cancelled) setAuthState("valid");
      } catch (err) {
        const status = err && typeof err === "object" ? err.status : undefined;
        if (status === 401 || status === 404) {
          localStorage.removeItem("fw_token");
        }
        if (!cancelled) setAuthState("no-token");
      }
    };

    doValidate();

    const onFocus = () => doValidate();
    const onVisible = () => {
      if (document.visibilityState === "visible") doValidate();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  if (authState === "checking")
    return (
      <div className="flex items-center justify-center min-h-screen text-neutral-500">
        ...
      </div>
    );

  return <App authState={authState} />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    <Root />
  </ThemeProvider>
);
